export const isHeapReady = (method = "track") =>
  !!process.env.REACT_APP_RUN_ANALYTICS &&
  typeof window.heap?.[method] === "function";
